export default "__VITE_ASSET__CmtA$wfn__"